import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

function Header(props) {
  return (
    <div className="live-event-header">
      <h1>{props.title}</h1>
      {
        props.title && <span className="separator" style={{ backgroundColor: props.themeColorHex }} />
      }
      <p>{props.subtitle}</p>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  themeColorHex: PropTypes.string
}

export default Header
